<!-- Player Subscription editor page header + details card (Phase 3 editor template). -->

<template>
  <div class="pse-topbar">
    <header class="pe-header">
      <div class="pe-header__left">
        <div class="pe-header__title-row">
          <h1 class="bui-page-title">Player Subscription Editor</h1>
          <button
            type="button"
            class="pe-header__refresh"
            aria-label="Reload player subscription"
            :disabled="isLoading"
            @click="reloadPlayerSubscription()"
          >
            <PhArrowsClockwise :size="22" weight="bold" />
          </button>
        </div>
        <div class="pe-header__subtitle">{{ data.name }}</div>
      </div>
    </header>

    <InfoCard>
      <template #title>
        <h2 class="info-card__title-text">Subscription Details</h2>
      </template>

      <div class="field-content">
        <div class="d-flex field-row">
          <label for="pse-name" class="basis-1/2 text-sm font-bold">Name &#9733;</label>
          <TextField id="pse-name" v-model="data.name" class="basis-1/2" width="100%" />
        </div>
        <div class="d-flex field-row field-row--top">
          <label for="pse-description" class="basis-1/2 text-sm font-bold">Description</label>
          <TextField id="pse-description" multiline v-model="data.description" class="basis-1/2" width="100%" />
        </div>
        <div class="d-flex field-row">
          <label class="basis-1/2 text-sm font-bold">Active</label>
          <div class="basis-1/2">
            <CheckBoxField
              v-model="data.isActive"
              name="active"
              :suffix-label="false"
              :label-with-margin="false"
            />
          </div>
        </div>
      </div>
    </InfoCard>
  </div>
</template>

<script lang="ts" setup>
import { PhArrowsClockwise } from '@phosphor-icons/vue';
import TextField from '@/components/form-fields/TextField.vue';
import CheckBoxField from "@/components/form-fields/CheckboxField.vue";
import { usePlayerSubscription } from '../composables/playerSubscription';
import InfoCard from '@/components/bui/molecules/InfoCard/InfoCard.vue';

const {
  data,
  reloadPlayerSubscription,
  isLoading
} = usePlayerSubscription();

</script>

<style lang="scss" scoped>
@import '@/assets/styles/bui-editor-template';

.pse-topbar {
  display: flex;
  flex-direction: column;
  gap: var(--bui-page-section-gap, 24px);
}

/* Token-colour the checkbox field atom. */
.field-content {
  :deep(input[type='checkbox']) {
    accent-color: var(--bui-chk-checked-fill, #de3da9);
  }
}
</style>
